import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  VStack,
  Flex,
  Select,
  Spinner,
  HStack,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { common } from "../../constants/constants";
import { RepeatIcon } from "@chakra-ui/icons";

const REFRESH_INTERVALS = [
  { label: "10 seconds", value: 10000 },
  { label: "20 seconds", value: 20000 },
  { label: "30 seconds", value: 30000 },
  { label: "1 minute", value: 60000 },
];

export default function LogModal({ isOpen, onClose, logData, onRefresh,status }) {
  const [intervalMs, setIntervalMs] = useState(10000); // default to 10s
  const [isRefreshing, setIsRefreshing] = useState(false);
  const intervalRef = useRef(null);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await onRefresh();
    setIsRefreshing(false);
  };

  useEffect(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);

    if (isOpen && intervalMs > 0) {
      intervalRef.current = setInterval(() => {
        handleRefresh();
      }, intervalMs);
    }

    return () => clearInterval(intervalRef.current);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalMs, isOpen]);

  if (!logData || !Array.isArray(logData)) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex justify="space-between" align="center">
            <Text>{common.LOG_HISTORY}</Text>
            {status!=="success" && status!=="failed" && <HStack mr={6}>
              <RepeatIcon />
            <Select
              width="120px"
              size="sm"
              value={intervalMs}
              onChange={(e) => setIntervalMs(Number(e.target.value))}
            >
              {REFRESH_INTERVALS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
            </HStack>}
            
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody minH="400px" maxH="500px" overflowY="auto">
        {isRefreshing ? (
          <Flex justify="center" align="center" height="100%">
            <Spinner size="lg" />
          </Flex>
        ) : (
          <VStack align="start" spacing={2}>
            {logData?.length === 0 ? (
              <Text>{common.NO_LOGS_AVAILABLE}</Text>
            ) : (
              logData?.map((entry, index) => (
                <Flex
                  key={index}
                  p={2}
                  borderWidth={1}
                  borderRadius="md"
                  w="100%"
                  justify="space-between"
                  align="center"
                  gap={4}
                  wrap="wrap"
                >
                  <Text fontSize="sm" color="gray.600" fontWeight={400} whiteSpace="nowrap">
                    {dayjs(entry?.created_at).format("DD MMM YYYY, hh:mm:ss A")}
                  </Text>
                  <Text flex="1" fontWeight={500} isTruncated title={entry?.log_text}>
                    {entry?.log_text}
                  </Text>
                </Flex>
              ))
            )}
          </VStack>
        )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
